export const PERMISSION_DENIED = 'PermissionDenied';
export const ACCESS_DENIED_EXCEPTION = 'AccessDeniedException';
export const OWA_EXPLICIT_LOGON_EXCEPTION = 'OwaExplicitLogonException';
export const ERROR_NON_EXISTENT_MAILBOX_EXCEPTION = 'ErrorNonExistentMailboxException';
export const ERROR_BOOKING_API_EXCEPTION = 'ErrorBookingApiException';
export const NOT_FOUND_EXCEPTION = 'NotFound';
export const ERROR_DISABLED_BY_ADMIN = 'ErrorDisabledByAdmin';
